// EDIT BY ALI FOR DARK MODE
// ThemeProvider component for managing dark mode state
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  // Use the saved preference; with none saved, default to light (the OS preference is ignored).
  const getInitialMode = () => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode !== null) {
      return savedMode === "true";
    }
    return false;
  };

  const [darkMode, setDarkMode_] = useState(getInitialMode);

  // EDIT BY ALI FOR DARK MODE - Save preference to localStorage
  const setDarkMode = useCallback((newMode) => {
    setDarkMode_(newMode);
    localStorage.setItem("darkMode", newMode.toString());
  }, []);

  // EDIT BY ALI FOR DARK MODE - Toggle dark mode
  const toggleDarkMode = useCallback(() => {
    setDarkMode_((prevDarkMode) => {
      const nextDarkMode = !prevDarkMode;
      localStorage.setItem("darkMode", nextDarkMode.toString());
      return nextDarkMode;
    });
  }, []);

  // EDIT BY ALI FOR DARK MODE - Memoized value of the theme context
  const contextValue = useMemo(
    () => ({
      darkMode,
      setDarkMode,
      toggleDarkMode,
    }),
    [darkMode, setDarkMode, toggleDarkMode]
  );

  // EDIT BY ALI FOR DARK MODE - Set initial data-theme attribute on body
  useEffect(() => {
    document.body.setAttribute("data-theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  // EDIT BY ALI FOR DARK MODE - Provide the theme context to the children components
  return (
    <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>
  );
};

export const useThemeMode = () => {
  return useContext(ThemeContext);
};

export default ThemeProvider;
